<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="systemUserWorkLines"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button
            type="primary"
            @click="$refs.createWorkLineInfoHandler.open(0)">
          新建
        </el-button>
        <el-button
            type="danger"
            @click="deleteIds">
          批量删除
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="查询">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="productionLine" align="center" label="产线名称"/>
      <el-table-column prop="productionLineCode" align="center" label="产线代码"/>
      <el-table-column prop="process" align="center" label="工序"/>
      <el-table-column prop="processCode" align="center" label="工序代码"/>
      <el-table-column
          prop="employeeName"
          align="center"
          label="处理人">
        <template slot-scope="scope">
          <span
              type="danger"
              style="color: #2d8cf0;cursor: pointer;"
              @click="$refs.selectEmployee.open();getId(scope.row.pkid)">
            {{scope.row.employeeName}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <employee-select ref="selectEmployee" @select="selectEmployeeName" @save-success="getList(1)"/>
    <work-line-info-handler-create ref="createWorkLineInfoHandler" @save-success="getList(1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import WorkLineInfoHandlerCreate from "@/views/information/WorkLineInfoHandler/WorkLineInfoHandlerCreate";
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";

  export default {
    name: "WorkLineInfoHandlerList",
    components: {EmployeeSelect, WorkLineInfoHandlerCreate, VmTable, VmSearch},
    data() {
      return {
        idList: "",
        workLineInfoId: "",
        filter: {
          filter: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      getId(id) {
        this.workLineInfoId = id;
      },

      selectEmployeeName(row) {
        console.log(row);
        this.$http
          .get("basic", `systemUserWorkLines/mastPKID/${this.workLineInfoId}/systemUserID/${row.systemUserID}`)
          .then(() => {
            this.getList(-1);
            this.$message.success("成功");
          });
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.districtID);
          }
          //console.log(ids);
          this.$http
            .delete("basic","systemUserWorkLines/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","systemUserWorkLines",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
